// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"271":"8696f65e","722":"ec77fccd"}[chunkId] + ".css";
};